const styled = require('styled-components');

export const styledRefProp = styled.createGlobalStyle ? 'ref' : 'innerRef';
